/**
 * マスター・用語・画面（F5）のルートパス定義。
 *
 * アクター・ドメイン・動詞・単位の 4 一覧は、contract の型ごとの一覧クエリ（`listActors` /
 * `listDomains` / `listVerbs` / `listUnits`）で実装している。
 * 他の応答から拾い集めた部分集合を「アクター一覧」として出すと、権威表現（マスターの実体）と
 * 食い違う第 2 の表現になる（core-principles の一次表現原則）。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business マスター・用語・画面の一覧と詳細のルートパスを定義する。
 * @graph-connects none
 */
import type { FeatureRouteSets } from './feature-route-sets.js';

/** 画面カタログ一覧。 @graph-connects none */
export const SCREENS_ROUTE = '/screens';

/** 用語集の一覧。 @graph-connects none */
export const TERMS_ROUTE = '/terms';

/** アクターの一覧。 @graph-connects none */
export const ACTORS_ROUTE = '/actors';

/** ドメインの一覧。 @graph-connects none */
export const DOMAINS_ROUTE = '/domains';

/** 動詞の一覧。 @graph-connects none */
export const VERBS_ROUTE = '/verbs';

/** 単位の一覧。 @graph-connects none */
export const UNITS_ROUTE = '/units';

/** 画面詳細。 @graph-connects none */
export const SCREEN_DETAIL_ROUTE = '/screens/$screenId';

/** 用語詳細。本文の用語自動リンクの行き先。 @graph-connects none */
export const TERM_DETAIL_ROUTE = '/terms/$termId';

/**
 * 分類マスター詳細（アクター / ドメイン / ステージ / 動詞 / 単位）。
 *
 * 型をまたいで 1 ルートにするのは、応答（`getMasterDetail`）が `type` + `id` の
 * 1 procedure で型をまたいで扱うためである。型ごとにルートへ割ると、同じ応答の描画が複数箇所へ
 * 分かれて片方だけ古い表示のまま残る。
 * @graph-connects none
 */
export const MASTER_DETAIL_ROUTE = '/masters/$type/$id';

/** マスター・用語・画面のルートの集合。一覧も詳細も案件を検索条件で受ける。 @graph-connects none */
export const mastersRouteSets = {
  all: [
    SCREENS_ROUTE,
    TERMS_ROUTE,
    ACTORS_ROUTE,
    DOMAINS_ROUTE,
    VERBS_ROUTE,
    UNITS_ROUTE,
    SCREEN_DETAIL_ROUTE,
    TERM_DETAIL_ROUTE,
    MASTER_DETAIL_ROUTE,
  ],
  pjSearch: [
    SCREENS_ROUTE,
    TERMS_ROUTE,
    ACTORS_ROUTE,
    DOMAINS_ROUTE,
    VERBS_ROUTE,
    UNITS_ROUTE,
    SCREEN_DETAIL_ROUTE,
    TERM_DETAIL_ROUTE,
    MASTER_DETAIL_ROUTE,
  ],
  operationSearch: [],
  pjPath: [],
} as const satisfies FeatureRouteSets;
